export default __webpack_public_path__ + "static/media/auto-fix-high.7991f369.svg";